import React from 'react';
import SocialLink from './SocialLink';
import { socialLinks } from '../data/socialLinks';
import './LinksContainer.css';

const LinksContainer = () => {
    return (
        <main className="links-container">
            <div className="links-grid">
                {socialLinks.map((link, index) => (
                    <SocialLink 
                        key={link.title} 
                        link={link} 
                        index={index}
                    />
                ))}
            </div>
        </main>
    );
};

export default LinksContainer;